module.exports = __webpack_public_path__ + "img/user.4712f63c.png";